import { IInitAction } from './init'

// Action types
export enum types {
  NOTIFICATION_DISPLAY = 'NOTIFICATION_DISPLAY',
  NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE',
  NOTIFICATION_TRIGGER = 'NOTIFICATION_TRIGGER',
}

export interface INotification {
  type: any
  message: string
  correlationId?: string
}

export interface IDisplayNotificationAction extends INotification {
  type: types.NOTIFICATION_DISPLAY
}

export interface ICloseNotificationAction {
  type: types.NOTIFICATION_CLOSE
}

export interface INotificationTrigger extends INotification {
  type: types.NOTIFICATION_TRIGGER
}

export type NotificationsActionsType =
  | IDisplayNotificationAction
  | ICloseNotificationAction
  | INotificationTrigger
  | IInitAction

// Reducer types
export interface INotifications {
  open: boolean
  message: string
  correlationId?: string
}
